import getMatches from './getMatches'
import getVinculos from './getVinculos'
import saveObsForm from './saveObsForm'

export const getMatchesPromise = getMatches
export const getVinculosPromise = getVinculos
export const saveObsFormPromise = saveObsForm
